/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Center, Box, Grid, GridItem, Text, Button, Input, Checkbox, Select, Stack,
    NumberInput, NumberInputField, NumberInputStepper, NumberIncrementStepper, NumberDecrementStepper, 
    Flex,
    Link} from "@chakra-ui/react";
import "../Stylesheets/main.css";
import { useMediaQuery } from "react-responsive";
import { Helmet } from "react-helmet-async";
import { HmacMD5 } from "crypto-js";
import AutoSuggestBox from "../Components/AutoSuggestBox";
import AutoSuggestPostalBox from "../Components/AutoSuggestPostalBox";
import TotalCostDetailsCard from "../Components/TotalCostDetailsCard";
import { getAddtionalBinPricing, getRecyclingSizePricing, getStandardDomesticPricing } from "../utils/domesticPricingHelper";
import { getCommercialPricing } from "../utils/commercialPricingHelper";

// Default Base URL
const baseUrl = window.location.origin === "https://forms.maitland.nsw.gov.au" ? 
    process.env.REACT_APP_APIURL : process.env.REACT_APP_NONPRODAPIURL;

export default function WasteServices() {
    
    // Set small screen size
    const isSmallScreen = useMediaQuery({
        query: "(max-width: 800px)"
    });
    
    // Set Count Variable
    var count = 0;

    // Create states
    const [propertyRelationship, setPropertyRelationship] = useState('');
    const [serviceType, setServiceType] = useState('');
    const [serviceAgreementChecked, setServiceAgreementChecked] = useState(false);
    const [domesticServiceOption, setDomesticServiceOption] = useState('');    
    const [tokenExecuted, setTokenExecuted] = useState(false);
    const [accessToken , setAccessToken] = useState(null);
    const [sharedToken, setSharedToken] = useState(null);
    const [submittedDetails, setSubmittedDetails] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [deliveryAddress, setDeliveryAddress] = useState('');
    const [mailingAddress, setMailingAddress] = useState('');
    const [agency, setAgency] = useState('');
    const [lotNumber, setLotNumber] = useState('');
    const [planNumber, setPlanNumber] = useState('');
    const [assessmentNumber, setAssessmentNumber] = useState('');
    const [businessName, setBusinessName] = useState('');
    const [domesticeServiceBins, setDomesticServiceBins] = useState(0);
    const [wasteBinAddNew, setWasteBinAddNew] = useState(0);
    const [recycleBinAddNew, setRecycleBinAddNew] = useState(0);
    const [organicBinAddNew, setOrganicBinAddNew] = useState(0);
    const [wasteBinAdd, setWasteBinAdd] = useState(0);
    const [recycleBinAdd, setRecycleBinAdd] = useState(0);
    const [organicBinAdd, setOrganicBinAdd] = useState(0);
    const [changeRecycleBin, setChangeRecycleBin] = useState(0);
    const [wasteBinCom, setWasteBinCom] = useState(0);
    const [recycleBinCom, setRecycleBinCom] = useState(0);
    const [organicBinCom, setOrganicBinCom] = useState(0);
    const [changeRecycleBinCom, setChangeRecycleCom] = useState(0);
    const [requireAdditionalBins, setRequireAdditionalBins] = useState('no');
    const [newRecycleSize, setNewRecycleSize] = useState('240');
    const [addRecycleSize, setAddRecycleSize] = useState('240');
    const [resizeRecycleSize, setResizeRecycleSize] = useState('upsize');
    const [comRecycleSize, setComRecycleSize] = useState('240');
    const [comResizeRecycleSize, setComResizeRecycleSize] = useState('upsize');
    const [reference, setReference] = useState(null);
    const [pleaseWait, setPleaseWait] = useState(false);    
    const [esriToken, setEsriToken] = useState(null);    
    const [esriTokenExecuted, setEsriTokenExecuted] = useState(false);
    const [priceData, setPriceData] = useState([]);
    const [suburbOptions, setSuburbOptions] = useState();
    const [selectedSuburb, setSelectedSuburb] = useState();
    const [orderDetails, setOrderDetails] = useState();

    if (!tokenExecuted) {
        retreiveAccessToken();

        var thisReference = "INV-WSR" + new Date().getTime();
        setReference(thisReference);
    }

    function retreiveAccessToken() {        
        // Retreive Access Token for payment.
        fetch(baseUrl + "waste/fz-access-token", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setAccessToken(response.access_token);
            setSharedToken(response.shared_secret);
        })
        .catch(error => console.log(error));

        setTokenExecuted(true);
    }
    
    if (!esriTokenExecuted) {
        retreiveEsriToken();
    }
    
    function retreiveEsriToken() {        
        // Retreive Esri Token for autoSuggest.
        fetch(baseUrl + "waste/esri-token", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setEsriToken(response.message);
        })
        .catch(error => console.log(error));

        setEsriTokenExecuted(true);
    }

    function retreivePricingData() {        
        // Retreive Esri Token for autoSuggest.
        fetch(baseUrl + "waste/pricing", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            response.forEach((item, index) => {
                priceData.push({
                    wasteServiceType: item.wasteServiceType,
                    initalFee: item.initalFee,
                    annualFee: item.annualFee
                });
            });
            setPriceData(priceData);
        })
        .catch(error => console.log(error));
    }

    function getSuburbs() {        
        fetch(baseUrl + "wastetrack/suburbs", {
            method: "GET"
        })
        .then(response => response.json())
        .then(response => {
            setSuburbOptions(response.map((item) => {
                return {value: item, label: item};
            }));
        })
        .catch(error => console.log(error));
    }

    function handleSuburbChange(suburb) {
        if (suburb) {
            setSelectedSuburb(suburb)
        }
    }

    // Validation
    function checkInputHasValue(property) {
        if (property.value.length === 0) {
            flagRequired(property);
            count++;
        } else {
            removeFlagRequired(property);
        }
    }

    // Validate that the value entered looks like an email address.
    function ValidateEmail(input) {
        // Validation Regular Expression
        var validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;      
        if (!input.value.match(validRegex)) {  
            // If invalid flag that it's required and add to error count      
            flagRequired(input);
            count++;
        } 
    }
    
    function flagRequired(property) {
        property.style.borderColor = "red";
    } 

    function removeFlagRequired(property) {
        property.style.borderColor = "lightgray";
    }

    function handleAdditionBinsSelected(value) {
        setRequireAdditionalBins(value);

        setWasteBinAddNew(0);
        setRecycleBinAddNew(0);
        setOrganicBinAddNew(0);
    }

    function getTotalDomesticPrice() {
       
        if (domesticServiceOption === "standardService") {
            const standardPricingDetails = getStandardDomesticPricing(domesticeServiceBins, wasteBinAddNew, recycleBinAddNew, organicBinAddNew, priceData);
            setOrderDetails(standardPricingDetails);
        }

        if (domesticServiceOption === "additionalBins") {
            const additionalBinsPricingDetails = getAddtionalBinPricing(wasteBinAdd, recycleBinAdd, organicBinAdd, priceData);
            setOrderDetails(additionalBinsPricingDetails);
        }

        if (domesticServiceOption === "recyclingSize") {
            const recyclingSizePricingDetails = getRecyclingSizePricing(changeRecycleBin, priceData);
            setOrderDetails(recyclingSizePricingDetails);
        }
    }

    function getTotalCommercialPrice() {
        const commercialPricingDetails = getCommercialPricing(priceData, wasteBinCom, recycleBinCom, organicBinCom, changeRecycleBinCom);
        setOrderDetails(commercialPricingDetails);
    }

    useEffect(() => {
        if (priceData.length === 0) {
            return;
        }

        if (serviceType === 'domestic') {
            getTotalDomesticPrice();
        } else {
            getTotalCommercialPrice();
        }
        
    }, [domesticeServiceBins, 
        wasteBinAddNew, 
        recycleBinAddNew, 
        organicBinAddNew, 
        wasteBinAdd, 
        recycleBinAdd, 
        organicBinAdd, 
        changeRecycleBin, 
        domesticServiceOption, 
        wasteBinCom, 
        recycleBinCom, 
        organicBinCom, 
        changeRecycleBinCom,
        serviceType
    ]);

    useEffect(() => {
        if (!suburbOptions) {
            getSuburbs();
        }

        if (priceData.length === 0) {
            retreivePricingData();        
        }
    }, []);

    // Main Content Return
    return (
        <>
            <Helmet>
                <meta http-equiv="Content-Security-Policy" content={`default-src 'self'; style-src 'self' https://maitlandapi.wpengine.com/mccds/ 'unsafe-inline'; 
                    connect-src 'self' ${baseUrl}waste/ ${baseUrl}wastetrack/ 
                    https://geocode-api.arcgis.com/arcgis/rest/services/World/GeocodeServer/suggest`} />
            </Helmet>
            {!submittedDetails &&
            <>
                <WasteServiceRequestForm />
            </>
            }
            
            {submittedDetails &&
            <>
                <Center>
                    <Button onClick={() => { handleCancelAndReturn(); setServiceAgreementChecked(false);} } size="lg" variant="Primary">&lt; Return to add further waste services</Button>
                </Center>
            </>
            }
        </>
    )

    // Conditional Render functions
    function WasteServiceRequestForm() {
        return(
            <>
                <Box marginTop='2%' marginLeft='5%' maxW='90%'>
                    <Grid templateColumns='repeat(1, 1fr)' gap={3}>
                        <GridItem w='100%'>
                            <Text fontSize='xl' fontWeight="bold">Relationship with the property:</Text>
                            <Select onChange={(e) => { setPropertyRelationship(e.target.value); PersistValues(); PersistAdditionalValues(); }} placeholder="- Please Select Property Relationship -"
                                value={propertyRelationship} size="lg" focusBorderColor="green.500" height="40px">
                                    <option value={'owner'}>Property Owner</option>
                                    <option value={'agent'}>Managing Agent</option>
                                </Select>
                            <br />
                            {propertyRelationship && <>
                                <PropertyForm />
                                <BinDeliveryDetails />
                                </> }
                        </GridItem>
                    </Grid>
                </Box>
            </>
        );
    }

    // Displays always
    function ServiceAgreement() {
        return (
            <>
                <Text fontSize='xl' fontWeight="bold">Agreement</Text><br />
                <Text fontSize="lg">Waste service connections are charged upon completion of this form. 
                Associated service charges are applied to annual property rates. For more information about waste service charges, 
                see Council's current <a href="https://www.maitland.nsw.gov.au/council/about-council/financial-reports-and-strategies#fees-and-charges" target="_blank" rel="noreferrer">Fees and Charges</a>.</Text>
                <br />
                {orderDetails && (
                    <TotalCostDetailsCard 
                        fullName={`${firstName} ${lastName}`}
                        deliveryAddress={deliveryAddress}
                        isSmallScreen={isSmallScreen}
                        orderDetails={orderDetails}
                    />
                )}
                <Checkbox size="lg" colorScheme="green" isChecked={serviceAgreementChecked} onChange={(e) => { setServiceAgreementChecked(e.target.checked); PersistValues(); PersistAdditionalValues(); }}>
                Accept<Text textTransform="lowercase"><span style={{"textTransform" : "uppercase"}}>I</span> understand that the annual service charges will be added to the property rates and are 
                payable on a quarterly basis by the rateable property owner.</Text></Checkbox><br />         
            </>
        );
    }

    // Will display if customer checks they're the property owner.
    function PropertyForm() {
        return(
            <>
                <Text fontSize='xl' fontWeight="bold">Property Owner Details</Text>
                <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">First Name<span className="requiredField">Required</span></Text>
                        <Input id="firstName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={firstName} />
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Last Name<span className="requiredField">Required</span></Text>
                        <Input id="lastName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={lastName} />
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Phone Number<span className="requiredField">Required</span></Text>
                        <Input id="phoneNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={phoneNumber} type="number" onWheel={(e) => e.target.blur()} />
                    </GridItem>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Email Address<span className="requiredField">Required</span></Text>
                        <Input id="emailAddress" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={emailAddress} />
                    </GridItem>
                </Grid>
                <br />
                <Grid templateColumns='repeat(1, 1fr)' gap={3}>
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Mailing Address<span className="requiredField">Required</span></Text>
                        <AutoSuggestPostalBox mailingAddress={mailingAddress} esriToken={esriToken}/>
                    </GridItem>
                {propertyRelationship === "agent" &&
                    <GridItem w='100%'>
                        <Text fontSize="md" fontWeight="bold">Agency</Text>
                        <Input id="agencyMA" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={agency} />
                    </GridItem>
                }
                </Grid>
                <br />
            </>
        )
    }

    // Displays when the customer accepts the service agreement
    function BinDeliveryDetails() {
        return (
            <>
                <Flex flexDirection='column' gap={2}>
                    <Text fontSize='xl' fontWeight="bold">Bin Delivery Details</Text>
                    <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'} gap={2}>
                        <GridItem colSpan={2}>
                            <Text fontSize="md" fontWeight="bold">Delivery Address<span className="requiredField">Required</span></Text>
                            <AutoSuggestBox handleSuburbChange={handleSuburbChange} deliveryAddress={deliveryAddress} persistValues={PersistValues} setDeliveryAddress={setDeliveryAddress}/>
                        </GridItem>
                        <GridItem colSpan={isSmallScreen ? 2 : 1}>
                            <Text fontSize='md' fontWeight="bold">Suburb<span className="requiredField">Required</span></Text>
                            <Select id="suburb" name="suburb" size="lg" onChange={(e) => {setSelectedSuburb(e.target.value); PersistValues();}} value={selectedSuburb} 
                                placeholder="- Please Select Suburb -" focusBorderColor="green.500" height="40px">
                                {suburbOptions && suburbOptions.map((suburb) => (
                                    <option key={suburb.value} value={suburb.value}>{suburb.label}</option>
                                ))}
                            </Select>
                        </GridItem>
                    </Grid>
                    <Grid border='1px solid #2874A6' backgroundColor='#EEF9FF' padding='12px' borderRadius='4px'>
                        <Text fontSize="16px" lineHeight="24px" fontWeight="600">Having trouble finding your address?</Text>
                        <Text fontSize="16px" lineHeight="24px">
                            If you're experiencing issues locating your address, please reach out to us for assistance. 
                            You can contact us on <Link href='tel:+61249349700'>02 4934 9700 </Link> 
                            or email us at <Link href='mailto:ask@maitland.nsw.gov.au'>ask@maitland.nsw.gov.au</Link>.
                        </Text>
                    </Grid>
                    <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={2}>
                        <GridItem w='100%'>                            
                            <Text fontSize="md" fontWeight="bold">Lot Number</Text>
                            <Input id="lotNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={lotNumber} />
                        </GridItem>
                        <GridItem w='100%'>                            
                            <Text fontSize="md" fontWeight="bold">DP/SP Number</Text>
                            <Input id="planNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={planNumber} />
                        </GridItem>
                        <GridItem w='100%'>                            
                            <Text fontSize="md" fontWeight="bold">Assessment Number</Text>
                            <Input id="assessmentNumber" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={assessmentNumber}/>
                        </GridItem>
                        <GridItem w='100%'>                            
                            <Text fontSize="md" fontWeight="bold">Business Name</Text>
                            <Input id="businessName" _hover={{border: "1px"}} height="40px" focusBorderColor="green.500" defaultValue={businessName}/>
                        </GridItem>
                    </Grid>
                    <Text fontSize='xl' fontWeight="bold">Service Type<span className="requiredField">Required</span></Text>
                    <Select size="lg" onChange={(e) => { setServiceType(e.target.value); PersistAdditionalValues(); PersistValues(); } } value={serviceType} 
                        placeholder="- Please Select Service Type -" focusBorderColor="green.500" height="40px">
                        <option value={'domestic'}>Domestic Service (Residential)</option>
                        <option value={'commercial'}>Commercial Service</option>
                    </Select>
                </Flex>
                {serviceType && <>
                    {serviceType === "domestic" ? <DomesticService /> : <CommercialService />}
                </>
                }
            </>
        );
    }

    // Displays if customer choose domestic service
    function DomesticService() {
        return (
            <>
                <br /><Text fontSize='xl' fontWeight="bold">Domestic Waste Service Options<span className="requiredField">Required</span></Text><br />
                <Select size="lg" onChange={(e) => { setDomesticServiceOption(e.target.value); PersistAdditionalValues(); }} value={domesticServiceOption}
                    placeholder="- Please Select Service Option -" focusBorderColor="green.500" height="40px">
                        <option value={'standardService'}>Domestic waste service package</option>
                        <option value={'additionalBins'}>Additional Bins</option>
                        <option value={'recyclingSize'}>Resize Recycling Bin</option>
                </Select>
                <br />
                {domesticServiceOption && <>
                    {domesticServiceOption === "standardService" &&
                        <>
                            <br /><Text fontSize='xl' fontWeight="bold">New Domestic Waste Service<span className="requiredField">Required</span></Text><br />
                            <Text fontSize="lg">Please choose how many Domestic Waste Service packages:</Text><br />
                            <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                <br />
                                <Center><Text fontSize='xl' fontWeight="bold">Domestic Waste Service</Text></Center>
                                <Center><Text fontSize='xl'>Upfront ${priceData[0].initalFee} + Annual ${priceData[0].annualFee} per service</Text></Center>
                                <Center><Text fontSize='sm'>(Includes 1 red, 1 yellow and 1 green bin)</Text></Center>
                                <br />
                                <Center>
                                    <Stack direction="row" spacing={5}>
                                        <Stack direction="column">
                                            <Text fontSize="lg">Services</Text>
                                            <NumberInput id="newServiceNumber" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                onChange={(e) => { setDomesticServiceBins(e); PersistAdditionalValues(); PersistValues();}} value={domesticeServiceBins}>
                                                <NumberInputField />
                                                <NumberInputStepper>
                                                    <NumberIncrementStepper />
                                                    <NumberDecrementStepper />
                                                </NumberInputStepper>
                                            </NumberInput>
                                        </Stack>
                                        <Stack direction="column">
                                            <Text fontSize="lg" w="140px"> Recycling Bin Size: </Text>                        
                                            <Select id="recycleSizeNew" size="lg" colorScheme="whatsapp" w="150px" onChange={(e) => { setNewRecycleSize(e.target.value); }} value={newRecycleSize}>
                                                <option value="240">240L</option>
                                                <option value="360">360L</option>
                                            </Select>
                                        </Stack>
                                    </Stack>
                                </Center>
                                <br />
                            </Box><br />
                            <Text fontSize='xl' fontWeight="bold">Do you require additional bin services</Text>
                            <Select size="lg" onChange={(e) => { handleAdditionBinsSelected(e.target.value); PersistAdditionalValues(); PersistValues(); }} value={requireAdditionalBins}
                                focusBorderColor="green.500" height="40px">
                                    <option value={'no'}>No</option>
                                    <option value={'yes'}>Yes</option>
                            </Select><br />
                            { requireAdditionalBins === 'yes' &&
                                <>
                                <Text fontSize='xl' fontWeight="bold">Additional Services</Text>
                                <Text fontSize='lg'>Please select any additional bins you require (these are <span className="boldFont">extra</span> and <span className="boldFont">optional</span> to the full service above):</Text> <br />
                                <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'} gap={3}>
                                    <GridItem w='100%'>
                                    <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                        <br />
                                        <Center><Text fontSize='xl' fontWeight="bold">Red General Waste Bin</Text></Center>
                                        <Center><Text fontSize='xl'>Upfront ${priceData[1].initalFee} + Annual ${priceData[1].annualFee} per bin</Text></Center>
                                        <br />
                                        <Center>
                                            <Stack direction="row" spacing={5}>
                                                <Stack direction="column">
                                                    <NumberInput id="wasteBinAddNew" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                    onChange={(e) => { setWasteBinAddNew(e); PersistAdditionalValues(); PersistValues();}} value={wasteBinAddNew}>
                                                        <NumberInputField />
                                                        <NumberInputStepper>
                                                            <NumberIncrementStepper />
                                                            <NumberDecrementStepper />
                                                        </NumberInputStepper>
                                                    </NumberInput>
                                                </Stack>
                                            </Stack>
                                        </Center>
                                        <br />
                                    </Box>
                                    </GridItem>
                                    <GridItem w='100%'>
                                    <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                        <br />
                                        <Center><Text fontSize='xl' fontWeight="bold">Yellow Recycling Bin</Text></Center>
                                        <Center><Text fontSize='xl'>Upfront ${priceData[2].initalFee} + Annual ${priceData[2].annualFee} per bin</Text></Center>
                                        <br />
                                        <Center>
                                            <Stack direction="row" spacing={5}>
                                                <Stack direction="column">
                                                    <NumberInput id="recycleBinAddNew" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                    onChange={(e) => { setRecycleBinAddNew(e); PersistAdditionalValues(); PersistValues();}} value={recycleBinAddNew}>
                                                        <NumberInputField />
                                                        <NumberInputStepper>
                                                            <NumberIncrementStepper />
                                                            <NumberDecrementStepper />
                                                        </NumberInputStepper>
                                                    </NumberInput>
                                                </Stack>
                                            </Stack>
                                        </Center>
                                        <br />
                                    </Box>
                                    </GridItem>
                                    <GridItem w='100%'>
                                    <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                        <br />
                                        <Center><Text fontSize='xl' fontWeight="bold">Green Organics Bin</Text></Center>
                                        <Center><Text fontSize='xl'>Upfront ${priceData[3].initalFee} + Annual ${priceData[3].annualFee} per bin</Text></Center>
                                        <br />
                                        <Center>
                                            <Stack direction="row" spacing={5}>
                                                <Stack direction="column">
                                                    <NumberInput id="organicBinAddNew" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                    onChange={(e) => { setOrganicBinAddNew(e); PersistAdditionalValues(); PersistValues();}} value={organicBinAddNew}>
                                                        <NumberInputField />
                                                        <NumberInputStepper>
                                                            <NumberIncrementStepper />
                                                            <NumberDecrementStepper />
                                                        </NumberInputStepper>
                                                    </NumberInput>  
                                                </Stack>
                                            </Stack>
                                        </Center>
                                        <br />
                                    </Box>
                                    </GridItem>
                                </Grid>
                                <br />
                                <Text fontSize="lg"><span className="boldFont">Please note:</span> To order additional bin for all three 
                                red, yellow & green bins. Ordering another full domestic service is the most cost-effective.</Text>
                            </>}
                            {propertyRelationship && <ServiceAgreement /> }
                            { serviceAgreementChecked && <>
                                <br />
                                <Box id="domesticNewError" bgColor="#ec131e" color="white" padding="15px" borderRadius="10px" className="hidden">
                                    <Center><Text id="domesticNewTitle" fontSize="xl" fontWeight="bold"></Text></Center>
                                    <Center><Text id="domesticNewMessage" fontSize="lg"></Text></Center>
                                </Box>
                                <Center><Button w="20%" variant="Primary" padding="25px" onClick={() => HandleNewDomesticSubmit()} isDisabled={pleaseWait}>{pleaseWait ? `Please Wait` : "Submit and Pay"}</Button></Center><br />
                            </>}
                        </>
                    }
                    {domesticServiceOption === "additionalBins" &&
                        <>
                            <br /><Text fontSize='xl' fontWeight="bold">Additional Bins<span className="requiredField">Required</span></Text><br />                               
                            <Text fontSize='lg'>Please select the additional bins you require:</Text> <br />
                            <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(3, 1fr)'} gap={3}>
                                <GridItem w='100%'>
                                <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                    <br />
                                    <Center><Text fontSize='xl' fontWeight="bold">Red General Waste Bin</Text></Center>
                                    <Center><Text fontSize='xl'>Upfront ${priceData[1].initalFee} + Annual ${priceData[1].annualFee} per bin</Text></Center>
                                    <br />
                                    <Center>
                                        <Stack direction="row" spacing={5}>
                                            <Stack direction="column">
                                                <NumberInput id="wasteBinAdd" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                onChange={(e) => { setWasteBinAdd(e); PersistAdditionalValues(); PersistValues();}} value={wasteBinAdd}>
                                                    <NumberInputField />
                                                    <NumberInputStepper>
                                                        <NumberIncrementStepper />
                                                        <NumberDecrementStepper />
                                                    </NumberInputStepper>
                                                </NumberInput>
                                            </Stack>
                                        </Stack>
                                    </Center>
                                    <br />
                                </Box>
                                </GridItem>
                                <GridItem w='100%'>
                                <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                    <br />
                                    <Center><Text fontSize='xl' fontWeight="bold">Yellow Recycling Bin</Text></Center>
                                    <Center><Text fontSize='xl'>Upfront ${priceData[2].initalFee} + Annual ${priceData[2].annualFee} per bin</Text></Center>
                                    <br />
                                    <Center>
                                        <Stack direction="row" spacing={5}>
                                            <Stack direction="column">
                                                <Center>
                                                <Stack direction="row" spacing={3}>
                                                    <NumberInput id="recycleBinAdd" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                    onChange={(e) => { setRecycleBinAdd(e); PersistAdditionalValues(); PersistValues();}} value={recycleBinAdd}>
                                                        <NumberInputField />
                                                        <NumberInputStepper>
                                                            <NumberIncrementStepper />
                                                            <NumberDecrementStepper />
                                                        </NumberInputStepper>
                                                    </NumberInput>                     
                                                    <Select id="recycleBinSizeAdd" size="lg" colorScheme="whatsapp" w="150px" onChange={(e) => { setAddRecycleSize(e.target.value); }} value={addRecycleSize}>
                                                        <option value="240">240L</option>
                                                        <option value="360">360L</option>
                                                    </Select>
                                                </Stack>
                                                </Center>
                                            </Stack>
                                        </Stack>
                                    </Center>
                                    <br />
                                </Box>
                                </GridItem>
                                <GridItem w='100%'>
                                <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                    <br />
                                    <Center><Text fontSize='xl' fontWeight="bold">Green Organics Bin</Text></Center>
                                    <Center><Text fontSize='xl'>Upfront ${priceData[3].initalFee} + Annual ${priceData[3].annualFee} per bin</Text></Center>
                                    <br />
                                    <Center>
                                        <Stack direction="row" spacing={5}>
                                            <Stack direction="column">                                                
                                                <NumberInput id="organicBinAdd" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                    onChange={(e) => { setOrganicBinAdd(e); PersistAdditionalValues(); PersistValues();}} value={organicBinAdd}>
                                                    <NumberInputField />
                                                    <NumberInputStepper>
                                                        <NumberIncrementStepper />
                                                        <NumberDecrementStepper />
                                                    </NumberInputStepper>
                                                </NumberInput>   
                                            </Stack>
                                        </Stack>
                                    </Center>
                                    <br />
                                </Box>
                                </GridItem>
                            </Grid>      
                            <br />
                            <Text fontSize='lg'><span className="boldFont">Please note</span> you need to have a domestic service before ordering additional bins. 
                            <br />If you are looking to obtain all 3 bins as an additional service, 
                            it is most cost effective to request another domestic waste service package</Text> <br />
                            {propertyRelationship && <ServiceAgreement /> }
                            { serviceAgreementChecked && <>
                                <br />
                                <Box id="domesticAddError" bgColor="#ec131e" color="white" padding="15px" borderRadius="10px" className="hidden">
                                    <Center><Text id="domesticAddTitle" fontSize="xl" fontWeight="bold"></Text></Center>
                                    <Center><Text id="domesticAddMessage" fontSize="lg"></Text></Center>
                                </Box>
                                <Center><Button w="20%" variant="Primary" padding="25px" onClick={() => HandleAdditionalDomesticSubmit()} isDisabled={pleaseWait}>{pleaseWait ? `Please Wait` : "Submit and Pay"}</Button></Center><br />
                            </>}
                        </>
                    }
                    {domesticServiceOption === "recyclingSize" &&
                        <>
                            <br /><Text fontSize='xl' fontWeight="bold">Resize Recycling Bin<span className="requiredField">Required</span></Text><br />                               
                            <Text fontSize='lg'>Please select the services and amount you want</Text> <br />
                            <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                                <br />
                                <Center><Text fontSize='xl' fontWeight="bold">Change Recycling Bin Size</Text></Center>
                                <Center><Text fontSize='xl'>Upfront ${priceData[2].initalFee} per bin</Text></Center>
                                <br />
                                <Center>
                                    <Stack direction="row" spacing={5}>
                                        <Stack direction="column">
                                            <NumberInput id="recycleBinChangeDom" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                                onChange={(e) => { setChangeRecycleBin(e); PersistAdditionalValues(); PersistValues();}} value={changeRecycleBin}>
                                                <NumberInputField />
                                                <NumberInputStepper>
                                                    <NumberIncrementStepper />
                                                    <NumberDecrementStepper />
                                                </NumberInputStepper>
                                            </NumberInput>
                                        </Stack>
                                        <Stack direction="column">
                                            <Select id="recycleBinChangeSizeDom" size="lg" colorScheme="whatsapp"  w="200px" onChange={(e) => { setResizeRecycleSize(e.target.value); }} value={resizeRecycleSize}>               
                                                <option value="upsize">Upsize (360L)</option>
                                                <option value="downsize">Downsize (240L)</option>
                                            </Select>
                                        </Stack>
                                    </Stack>
                                </Center>
                                <br />
                            </Box><br />
                            {propertyRelationship && <ServiceAgreement /> }
                            { serviceAgreementChecked && <>
                                <br />
                                <Box id="domesticChangeError" bgColor="#ec131e" color="white" padding="15px" borderRadius="10px" className="hidden">
                                    <Center><Text id="domesticChangeTitle" fontSize="xl" fontWeight="bold"></Text></Center>
                                    <Center><Text id="domesticChangeMessage" fontSize="lg"></Text></Center>
                                </Box>
                                <Center><Button w="20%" variant="Primary" padding="25px" onClick={() => HandleResizeDomesticSubmit()} isDisabled={pleaseWait}>{pleaseWait ? `Please Wait` : "Submit and Pay"}</Button></Center><br />
                            </>}
                        </>
                    }
                </>}
            </>
        );
    }

    // Displays if customer choose commercial service
    function CommercialService() {
        return (
            <>
                <br /><Text fontSize='xl' fontWeight="bold">Commercial Waste Service Options<span className="requiredField">Required</span></Text><br />                               
                <Text fontSize='lg'>Please select the services and amount you want</Text> <br />
                <Grid templateColumns={isSmallScreen ? 'repeat(1, 1fr)' : 'repeat(2, 1fr)'} gap={3}>
                    <GridItem w='100%'>
                    <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                        <br />
                        <Center><Text fontSize='xl' fontWeight="bold">Red General Waste Bin</Text></Center>
                        <Center><Text fontSize='xl'>Upfront ${priceData[4].initalFee} + Annual ${priceData[4].annualFee.toFixed(2)} per bin</Text></Center>
                        <br />
                        <Center>
                            <Stack direction="row" spacing={5}>
                                <Stack direction="column">
                                    <NumberInput id="wasteCom" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                    onChange={(e) => { setWasteBinCom(e); PersistAdditionalValues(); PersistValues();}} value={wasteBinCom}>
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>
                                </Stack>
                            </Stack>
                        </Center>
                        <br />
                    </Box>
                    </GridItem>
                    <GridItem w='100%'>
                    <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                        <br />
                        <Center><Text fontSize='xl' fontWeight="bold">Yellow Recycling Bin</Text></Center>
                        <Center><Text fontSize='xl'>Upfront ${priceData[5].initalFee} + Annual ${priceData[5].annualFee} per bin</Text></Center>
                        <br />
                        <Center>
                            <Stack direction="row" spacing={5}>
                                <Stack direction="column">
                                    <Center>
                                    <Stack direction="row" spacing={3}>
                                    <NumberInput id="recycleCom" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                        onChange={(e) => { setRecycleBinCom(e); PersistAdditionalValues(); PersistValues();}} value={recycleBinCom}>
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>                      
                                    <Select id="recycleSize" size="lg" colorScheme="whatsapp" w="150px" onChange={(e) => { setComRecycleSize(e.target.value); }} value={comRecycleSize}>
                                            <option value="240">240L</option>
                                            <option value="360">360L</option>
                                    </Select>  
                                    </Stack>
                                    </Center>
                                </Stack>
                            </Stack>
                        </Center>
                        <br />
                    </Box>
                    </GridItem>
                    <GridItem w='100%'>
                    <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                        <br />
                        <Center><Text fontSize='xl' fontWeight="bold">Green Organics Bin</Text></Center>
                        <Center><Text fontSize='xl'>Upfront ${priceData[6].initalFee} + Annual ${priceData[6].annualFee} per bin</Text></Center>
                        <br />
                        <Center>
                            <Stack direction="row" spacing={5}>
                                <Stack direction="column">                                                
                                    <NumberInput id="organicCom" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                        onChange={(e) => { setOrganicBinCom(e); PersistAdditionalValues(); PersistValues();}} value={organicBinCom}>
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>  
                                </Stack>
                            </Stack>
                        </Center>
                        <br />
                    </Box>
                    </GridItem>
                    <GridItem w='100%'>
                    <Box width="100%" marginTop="10px" border='1px' borderRadius='md' borderColor='gray.300'>
                        <br />
                        <Center><Text fontSize='xl' fontWeight="bold">Change Recycling Bin Size</Text></Center>
                        <Center><Text fontSize='xl'>Upfront ${priceData[5].initalFee}</Text></Center>
                        <br />
                        <Center>
                            <Stack direction="row" spacing={5}>
                                <Stack direction="column">
                                    <Center>
                                    <Stack direction="row" spacing={3}>
                                    <NumberInput id="changeSizeCom" step={1} defaultValue={0} min={0} max={10} focusBorderColor="green.500" size="lg" fontSize="lg" border="1px" w="50px"
                                        onChange={(e) => { setChangeRecycleCom(e); PersistAdditionalValues(); PersistValues();}} value={changeRecycleBinCom}>
                                        <NumberInputField />
                                        <NumberInputStepper>
                                            <NumberIncrementStepper />
                                            <NumberDecrementStepper />
                                        </NumberInputStepper>
                                    </NumberInput>
                                    <Select id="changeRecycleSize" size="lg" colorScheme="whatsapp" w="200px" onChange={(e) => { setComResizeRecycleSize(e.target.value); }} value={comResizeRecycleSize}>
                                            <option value="upsize">Upsize (360L)</option>
                                            <option value="downsize">Downsize (240L)</option>
                                    </Select>
                                    </Stack>
                                    </Center>
                                </Stack>
                            </Stack>
                        </Center>
                        <br />
                    </Box>
                    </GridItem>
                </Grid>      
                <br />                
                {propertyRelationship && <ServiceAgreement /> }
                { serviceAgreementChecked && <><br />
                    <Box id="commercialError" bgColor="#ec131e" color="white" padding="15px" borderRadius="10px" className="hidden">
                        <Center><Text id="commercialTitle" fontSize="xl" fontWeight="bold"></Text></Center>
                        <Center><Text id="commercialMessage" fontSize="lg"></Text></Center>
                    </Box>
                    <Center><Button w="20%" variant="Primary" padding="25px" onClick={() => HandleCommercialSubmit()} isDisabled={pleaseWait}>{pleaseWait ? `Please Wait` : "Submit and Pay"}</Button></Center><br />
                </> }
            </>
        );
    }
    
    // Api call
    function deleteWasteServicePost() {
        // Store details on property certificate
        var parameters = "?emailAddress=" + emailAddress + "&accessToken=" + accessToken;

        fetch(baseUrl + "waste/services" + parameters, {
            method: "DELETE",
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(response => response.json())
        .then(response => {           
            setPleaseWait(false);
        })
        .catch(error => console.log(error));
        return true;
    }

    function handleCancelAndReturn() {
        // Create new invoice number
        var newReference = "INV-WSR" + new Date().getTime();
        setReference(newReference);
        // Return to page > Delete cancel from database if not paid > reload page
        setSubmittedDetails(false);
        deleteWasteServicePost();
    }

    // Persist Personal Detail Values when changing between Acknowledge statement and Changing Agent/Owner 
    function PersistValues() {        
        var firstName = document.getElementById("firstName");
        var lastName = document.getElementById("lastName");
        var phoneNumber = document.getElementById("phoneNumber");
        var emailAddress = document.getElementById("emailAddress");
        var address = document.getElementById("propertyAddress");
        var postalAddress = document.getElementById("postalAddress");
        var agency = document.getElementById("agencyMA");

        if (firstName && firstName.value) {
            setFirstName(firstName.value);
        }
        if (lastName && lastName.value) {
            setLastName(lastName.value);
        }
        if (phoneNumber && phoneNumber.value) {
            setPhoneNumber(phoneNumber.value);
        }
        if (emailAddress && emailAddress.value) {
            setEmailAddress(emailAddress.value);
        }
        if (address && address.value) {
            setDeliveryAddress(address.value);
        }
        if (postalAddress && postalAddress.value) {
            setMailingAddress(postalAddress.value);
        }
        if (agency && agency.value) {
            setAgency(agency.value);
        }
    }

    // Persist Bin Detail Values (Non-Required Fields)
    function PersistAdditionalValues() {        
        var lotNumber = document.getElementById("lotNumber");
        var planNumber = document.getElementById("planNumber");
        var assessmentNumber = document.getElementById("assessmentNumber");
        var businessName = document.getElementById("businessName");

        if (lotNumber) {
            setLotNumber(lotNumber.value);
        }
        
        if (planNumber) {
            setPlanNumber(planNumber.value);
        }
        
        if (assessmentNumber) {
            setAssessmentNumber(assessmentNumber.value);
        }
        
        if (businessName) {
            setBusinessName(businessName.value);
        }
    }

    function HandleCommercialSubmit() {
        // Make sure count starts off as 0
        count = 0;
        // Get Required Fields
        var firstName = document.getElementById("firstName");
        var lastName = document.getElementById("lastName");
        var phoneNumber = document.getElementById("phoneNumber");
        var emailAddress = document.getElementById("emailAddress");
        var address = document.getElementById("propertyAddress");
        var postalAddress = document.getElementById("postalAddress");
        var suburb = document.getElementById("suburb");
        
        // Add all required fields into an array
        var requiredFields = [firstName, lastName, emailAddress, phoneNumber, address, postalAddress, suburb];
            
        // Loop through the array and validate each item
        requiredFields.forEach(function(thisField){
            checkInputHasValue(thisField);
        });

        ValidateEmail(emailAddress);

        if (count === 0 ) {   
            if (accessToken != null) {
                var wasteCom = document.getElementById('wasteCom').value;
                var recycleCom = document.getElementById('recycleCom').value;
                var organicCom = document.getElementById('organicCom').value;
                var changeSizeCom = document.getElementById('changeSizeCom').value;
                var recycleSize = document.getElementById('recycleSize').value;
                var changeRecycleSize = document.getElementById('changeRecycleSize').value;

                var getWaste = priceData[4];
                var getRecycle = priceData[5];
                var getOrganic = priceData[6];

                var wastePrice = getWaste.initalFee * wasteCom;
                var recyclePrice = getRecycle.initalFee * recycleCom;
                var organicPrice = getOrganic.initalFee * organicCom;
                var changeSizePrice = getRecycle.initalFee * changeSizeCom;

                var thisTotalPrice = wastePrice + recyclePrice + organicPrice + changeSizePrice; 

                var wasteServiceRequestModel = JSON.stringify({
                    "propertyOwner": propertyRelationship === "owner" ? true : false,
                    "managingAgent": propertyRelationship === "agent" ? true : false,
                    "firstName": firstName.value,
                    "lastName": lastName.value,
                    "phoneNumber": phoneNumber.value,
                    "emailAddress": emailAddress.value,
                    "deliveryAddress": `${address.value} (${suburb.value})`,
                    "postalAddress": postalAddress.value,
                    "agency": agency,
                    "lotNumber": lotNumber,
                    "planNumber": planNumber,
                    "assessmentNumber": assessmentNumber,
                    "businessName": businessName,
                    "serviceType": "Commercial",
                    "wasteBins": wasteCom,
                    "recyclingBins": recycleCom,
                    "recyclingBinSizes": recycleCom > 0 ? recycleSize : "",
                    "organicBins": organicCom,
                    "changeRecyclingBins": changeSizeCom,
                    "changeRecyclingBinSizes": changeSizeCom > 0 ? changeRecycleSize : "",
                    "isNewServiceRequest" : false,
                    "paymentAmount": thisTotalPrice,                    
                    "accessToken": accessToken,
                    "invoiceNumber" : reference
                });

                if (wasteCom < 1 && recycleCom < 1 && organicCom < 1 && changeSizeCom < 1) {
                    var errorMessage = "Please add atleast one bin to proceed to purchase.";

                    // Set text for error messages
                    document.getElementById("commercialTitle").innerText = "No bins selected";
                    document.getElementById("commercialMessage").innerText = errorMessage;
                    document.getElementById("commercialError").classList.remove("hidden");
                } else {
                    var amount = thisTotalPrice * 100;
                    wasteServiceRequestPost(wasteServiceRequestModel, amount);
                }
            }
        } else {
            var toastMessage = "Please Fill in Required Fields";
            // Set text for error messages
            document.getElementById("commercialTitle").innerText = "Additional information needed";
            document.getElementById("commercialMessage").innerText = toastMessage;
            document.getElementById("commercialError").classList.remove("hidden");
        }
    }

    function HandleNewDomesticSubmit() {
        // Make sure count starts off as 0
        count = 0;
        // Get Required Fields
        var firstName = document.getElementById("firstName");
        var lastName = document.getElementById("lastName");
        var phoneNumber = document.getElementById("phoneNumber");
        var emailAddress = document.getElementById("emailAddress");
        var address = document.getElementById("propertyAddress");
        var postalAddress = document.getElementById("postalAddress");
        let suburb = document.getElementById("suburb");
        
        // Add all required fields into an array
        var requiredFields = [firstName, lastName, emailAddress, phoneNumber, address, postalAddress, suburb];
            
        // Loop through the array and validate each item
        requiredFields.forEach(function(thisField){
            checkInputHasValue(thisField);
        });

        ValidateEmail(emailAddress);
        

        if (count === 0 ) {   
            if (accessToken != null) {
                var newServiceNumber = document.getElementById('newServiceNumber').value;
                var recycleSizeNew = document.getElementById('recycleSizeNew').value;

                var wasteBinAddNew = document.getElementById('wasteBinAddNew') ? document.getElementById('wasteBinAddNew').value : 0;
                var recycleBinAddNew = document.getElementById('recycleBinAddNew') ? document.getElementById('recycleBinAddNew').value : 0;
                var organicBinAddNew = document.getElementById('organicBinAddNew') ? document.getElementById('organicBinAddNew').value : 0;

                var getNewService = priceData[0];
                var getWaste = priceData[1];
                var getRecycle = priceData[2];
                var getOrganic = priceData[3];

                var newServicePrice = getNewService.initalFee * newServiceNumber;
                var wastePrice = getWaste.initalFee * wasteBinAddNew;
                var recyclePrice = getRecycle.initalFee * recycleBinAddNew;
                var organicPrice = getOrganic.initalFee * organicBinAddNew; 

                var thisTotalPrice = newServicePrice + wastePrice + recyclePrice + organicPrice; 

                var wasteServiceRequestModel = JSON.stringify({
                    "propertyOwner": propertyRelationship === "owner" ? true : false,
                    "managingAgent": propertyRelationship === "agent" ? true : false,
                    "firstName": firstName.value,
                    "lastName": lastName.value,
                    "phoneNumber": phoneNumber.value,
                    "emailAddress": emailAddress.value,
                    "deliveryAddress": `${address.value} (${suburb.value})`,
                    "postalAddress": postalAddress.value,
                    "agency": agency,
                    "lotNumber": lotNumber,
                    "planNumber": planNumber,
                    "assessmentNumber": assessmentNumber,
                    "businessName": businessName,
                    "serviceType": "Domestic - New Service",
                    "wasteBins": parseInt(newServiceNumber) + parseInt(wasteBinAddNew),
                    "recyclingBins": parseInt(newServiceNumber) + parseInt(recycleBinAddNew),
                    "recyclingBinSizes": recycleSizeNew,
                    "organicBins": parseInt(newServiceNumber) + parseInt(organicBinAddNew),
                    "changeRecyclingBins": 0,
                    "changeRecyclingBinSizes": "",
                    "isNewServiceRequest" : true,
                    "paymentAmount": thisTotalPrice,                    
                    "accessToken": accessToken,
                    "invoiceNumber" : reference
                });

                if (newServiceNumber < 1) {
                    var errorMessage = "Please add atleast one bin to proceed to purchase.";
                    
                    // Set text for error messages
                    document.getElementById("domesticNewTitle").innerText = "No bins selected";
                    document.getElementById("domesticNewMessage").innerText = errorMessage;
                    document.getElementById("domesticNewError").classList.remove("hidden");

                } else if (wasteBinAddNew > 0 && recycleBinAddNew > 0 && organicBinAddNew > 0) {
                    var toManyBinsMessage = "To order additional bin for all three red, yellow & green bins. Ordering another full domestic service is the most cost-effective.";

                    // Set text for error messages
                    document.getElementById("domesticNewTitle").innerText = "Too many bins selected";
                    document.getElementById("domesticNewMessage").innerText = toManyBinsMessage;
                    document.getElementById("domesticNewError").classList.remove("hidden");
                } else {
                    var amount = thisTotalPrice * 100;
                    wasteServiceRequestPost(wasteServiceRequestModel, amount);
                }
            }
        } else {
            var toastMessage = "Please fill in required fields";
            
            // Set text for error messages
            document.getElementById("domesticNewTitle").innerText = "Additional information needed";
            document.getElementById("domesticNewMessage").innerText = toastMessage;
            document.getElementById("domesticNewError").classList.remove("hidden");
        }
    }

    function HandleAdditionalDomesticSubmit() {
        // Make sure count starts off as 0
        count = 0;
        // Get Required Fields
        var firstName = document.getElementById("firstName");
        var lastName = document.getElementById("lastName");
        var phoneNumber = document.getElementById("phoneNumber");
        var emailAddress = document.getElementById("emailAddress");
        var address = document.getElementById("propertyAddress");
        var postalAddress = document.getElementById("postalAddress");
        let suburb = document.getElementById("suburb");
        
        // Add all required fields into an array
        var requiredFields = [firstName, lastName, emailAddress, phoneNumber, address, postalAddress, suburb];
            
        // Loop through the array and validate each item
        requiredFields.forEach(function(thisField){
            checkInputHasValue(thisField);
        });

        ValidateEmail(emailAddress);

        if (count === 0 ) {   
            if (accessToken != null) {
                var wasteBinAdd = document.getElementById('wasteBinAdd').value;
                var recycleBinAdd = document.getElementById('recycleBinAdd').value;
                var organicBinAdd = document.getElementById('organicBinAdd').value;
                var recycleBinSizeAdd = document.getElementById('recycleBinSizeAdd').value;

                var getWaste = priceData[1];
                var getRecycle = priceData[2];
                var getOrganic = priceData[3];

                var wastePrice = getWaste.initalFee * wasteBinAdd;
                var recyclePrice = getRecycle.initalFee * recycleBinAdd;
                var organicPrice = getOrganic.initalFee * organicBinAdd;

                var thisTotalPrice = wastePrice + recyclePrice + organicPrice; 

                var wasteServiceRequestModel = JSON.stringify({
                    "propertyOwner": propertyRelationship === "owner" ? true : false,
                    "managingAgent": propertyRelationship === "agent" ? true : false,
                    "firstName": firstName.value,
                    "lastName": lastName.value,
                    "phoneNumber": phoneNumber.value,
                    "emailAddress": emailAddress.value,
                    "deliveryAddress": `${address.value} (${suburb.value})`,
                    "postalAddress": postalAddress.value,
                    "agency": agency,
                    "lotNumber": lotNumber,
                    "planNumber": planNumber,
                    "assessmentNumber": assessmentNumber,
                    "businessName": businessName,
                    "serviceType": "Domestic - Additional Bins",
                    "wasteBins": wasteBinAdd,
                    "recyclingBins": recycleBinAdd,
                    "recyclingBinSizes": recycleBinAdd > 0 ? recycleBinSizeAdd : "",
                    "organicBins": organicBinAdd,
                    "changeRecyclingBins": 0,
                    "changeRecyclingBinSizes": "",
                    "isNewServiceRequest" : false,
                    "paymentAmount": thisTotalPrice,                    
                    "accessToken": accessToken,
                    "invoiceNumber": reference
                });

                var toastMessage = "";
                if (wasteBinAdd > 0 && recycleBinAdd > 0 && organicBinAdd > 0) {
                    toastMessage = "It looks like you're adding at least 1 bin from each category. " +
                        "It’s more financially viable to bundle the three bins into the domestic waste service package. " +
                        "Please select Domestic waste service package from the ‘service options’ drop-down list above and add any additional bins you may require that way.";

                    // Set text for error messages
                    document.getElementById("domesticAddTitle").innerText = "Warning";
                    document.getElementById("domesticAddMessage").innerText = toastMessage;
                    document.getElementById("domesticAddError").classList.remove("hidden");
                } else if (wasteBinAdd < 1 && recycleBinAdd < 1 && organicBinAdd < 1) {
                    toastMessage = "Please add atleast one bin to proceed to purchase.";
                    
                    // Set text for error messages
                    document.getElementById("domesticAddTitle").innerText = "No bins selected";
                    document.getElementById("domesticAddMessage").innerText = toastMessage;
                    document.getElementById("domesticAddError").classList.remove("hidden");
                } else {
                    var amount = thisTotalPrice * 100;
                    wasteServiceRequestPost(wasteServiceRequestModel, amount);
                }
            }
        } else {
            toastMessage = "Please fill in all required fields";

            // Set text for error messages
            document.getElementById("domesticAddTitle").innerText = "Additional information needed";
            document.getElementById("domesticAddMessage").innerText = toastMessage;
            document.getElementById("domesticAddError").classList.remove("hidden");
        }
    }
    
    function HandleResizeDomesticSubmit() {
        // Make sure count starts off as 0
        count = 0;
        // Get Required Fields
        var firstName = document.getElementById("firstName");
        var lastName = document.getElementById("lastName");
        var phoneNumber = document.getElementById("phoneNumber");
        var emailAddress = document.getElementById("emailAddress");
        var address = document.getElementById("propertyAddress");
        var postalAddress = document.getElementById("postalAddress");
        let suburb = document.getElementById("suburb");
        
        // Add all required fields into an array
        var requiredFields = [firstName, lastName, emailAddress, phoneNumber, address, postalAddress, suburb];
            
        // Loop through the array and validate each item
        requiredFields.forEach(function(thisField){
            checkInputHasValue(thisField);
        });

        ValidateEmail(emailAddress);

        if (count === 0 ) {   
            if (accessToken != null) {
                var recycleBinChangeDom = document.getElementById('recycleBinChangeDom').value;
                var recycleBinChangeSizeDom = document.getElementById('recycleBinChangeSizeDom').value;

                var getRecycle = priceData[2];

                var changeSizePrice = getRecycle.initalFee * recycleBinChangeDom;

                var thisTotalPrice = changeSizePrice; 

                var wasteServiceRequestModel = JSON.stringify({
                    "propertyOwner": propertyRelationship === "owner" ? true : false,
                    "managingAgent": propertyRelationship === "agent" ? true : false,
                    "firstName": firstName.value,
                    "lastName": lastName.value,
                    "phoneNumber": phoneNumber.value,
                    "emailAddress": emailAddress.value,
                    "deliveryAddress": `${address.value} (${suburb.value})`,
                    "postalAddress": postalAddress.value,
                    "agency": agency,
                    "lotNumber": lotNumber,
                    "planNumber": planNumber,
                    "assessmentNumber": assessmentNumber,
                    "businessName": businessName,
                    "serviceType": "Domestic - Change Bin Size",
                    "wasteBins": 0,
                    "recyclingBins": 0,
                    "recyclingBinSizes": "",
                    "organicBins": 0,
                    "changeRecyclingBins": recycleBinChangeDom,
                    "changeRecyclingBinSizes": recycleBinChangeDom > 0 ? recycleBinChangeSizeDom : "",
                    "isNewServiceRequest" : false,
                    "paymentAmount": thisTotalPrice,                    
                    "accessToken": accessToken,
                    "invoiceNumber" : reference
                });

                if (recycleBinChangeDom < 1 ) {
                    var errorMessage = "Please add atleast one bin to proceed to purchase.";

                    // Set text for error messages
                    document.getElementById("domesticChangeTitle").innerText = "No bins selected";
                    document.getElementById("domesticChangeMessage").innerText = errorMessage;
                    document.getElementById("domesticChangeError").classList.remove("hidden");
                } else {
                    var amount = thisTotalPrice * 100;
                    wasteServiceRequestPost(wasteServiceRequestModel, amount);
                }
            }
        } else {
            var toastMessage = "Please fill in required fields";

            // Set text for error messages
            document.getElementById("domesticChangeTitle").innerText = "Additional information needed";
            document.getElementById("domesticChangeMessage").innerText = toastMessage;
            document.getElementById("domesticChangeError").classList.remove("hidden");
        }
    }

    // Api call
    function wasteServiceRequestPost(wasteServiceRequestModel, amount) {
        // Store details on property certificate
        // Set please wait for slow browsers
        setPleaseWait(true);
        fetch(baseUrl + "waste/services", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: wasteServiceRequestModel
        })
        .then(response => response.json())
        .then(response => {           
            if (response.statusCode === 200) {
                navigateToFatZebra(amount);
            }
        })
        .catch(error => {
            console.log(error);
            // Undo please wait if error
            setPleaseWait(false);
        });
    }

    function navigateToFatZebra(amount) {
        // Navigate to FatZebra Payment
        var sharedSecret = sharedToken; 
        var fzUsername = "TESTmaitland";
        var paymentUrl = "https://paynow.pmnts-sandbox.io/v2";                
        var returnPath = "https://mcc-ae-nonprod-forms.azurewebsites.net/wasteservicespaid";
        if (window.location.origin === "https://forms.maitland.nsw.gov.au") {
            fzUsername = "maitlandbinorderform";
            paymentUrl = "https://paynow.pmnts.io/v2";
            returnPath = "https://forms.maitland.nsw.gov.au/wasteservicespaid";
        }

        var encrypted = HmacMD5([reference, amount, 'AUD', returnPath].join(':'),sharedSecret).toString();

        setSubmittedDetails(true);    
        window.top.location.href = `${paymentUrl}/${fzUsername}/${reference}/AUD/${amount}/${encrypted}?return_path=${returnPath}&amp;cards=&amp;show_email=false&amp;enable_sca=false&amp;hide_button=false&amp;tokenize_only=false&amp;hide_logos=true`;          
    }
}